import request from './client';

export function getMySurveys(propId) {
  return request({
    method: 'POST',
    url: '/api/v1/my-surveys/',
    data: { propId: propId },
    responseType: 'json'
  });
}

export function getMySurvey(id, hotelId) {
  return request({
    method: 'GET',
    url: `/api/v1/my-surveys/${id}/${hotelId}`,
    responseType: 'json'
  });
}

export function putFormValues(surveyId, hotelId, formId, values) {
  return request({
    method: 'PUT',
    url: `/api/v1/my-surveys/${surveyId}/${hotelId}/survey-forms/${formId}/values`,
    data: values,
    responseType: 'json'
  });
}

export function getStartSurvey(id, data) {
  return request({
    method: 'POST',
    url: `/api/v1/my-surveys/${id}/start`,
    data: data,
    responseType: 'json'
  });
}

export function submitSurveyEntry(surveyId, hotelId) {
  return request({
    methd: 'GET',
    url: `/api/v1/my-surveys/${surveyId}/${hotelId}/submit`,
    responseType: 'json'
  });
}

export function amendSurveyEntry(surveyId, hotelId) {
  return request({
    methd: 'GET',
    url: `/api/v1/my-surveys/${surveyId}/${hotelId}/amend`,
    responseType: 'json'
  });
}

export function createSurvey(data) {
  return request({
    method: 'POST',
    url: '/api/v1/surveys',
    data: data,
    responseType: 'json'
  });
}

export function getSurveys(options) {
  let page = options.page || 1;
  let name = options.name || "";
  let status = options.status || "";
  let surveyType = options.survey_type || "";

  return request({
    method: 'GET',
    url: '/api/v1/surveys' + '?page=' + page
          + (name !== "" ? '&name=' + name : "")
          + (status !== "" ? '&status=' + status : "")
          + (surveyType !== "" ? '&survey_type=' + surveyType : ""),
    responseType: 'json'
  });
}

export function getSurvey(id) {
  return request({
    method: 'GET',
    url: '/api/v1/surveys/' + id,
    responseType: 'json'
  });
}

export function updateSurvey(id, data) {
  return request({
    method: 'PUT',
    url: '/api/v1/surveys/' + id,
    data: data,
    responseType: 'json'
  });
}

export function getSurveyEntries(id, options) {
  let page = options.page || 1;
  let hotel = options.hotel || "";
  let limit = options.limit || 20;
  return request({
    method: 'GET',
    url: '/api/v1/surveys/' + id + '/entries' + '?page=' + page + '&limit=' + limit
        + (hotel !== "" ? '&hotel=' + hotel : ""),
    responseType: 'json'
  });
}

export function getSurveyEntry(entryId) {
  return request({
    method: 'GET',
    url: '/api/v1/entries/' +  entryId,
    responseType: 'json'
  });
}

export function putSurveyEntryValues(entryId, formId, values) {
  return request({
    method: 'PUT',
    url: '/api/v1/entries/' + entryId + '/survey-forms/' + formId + '/values',
    data: values,
    responseType: 'json'
  });
}


// WEBPACK FOOTER //
// ./src/gateways/surveys.js